export default {
  OFFICE_TYPES: [
    'ods',
    'xls',
    'xlsb',
    'xlsm',
    'xlsx',
    'one',
    'onetoc2',
    'onepkg',
    'odp',
    'pot',
    'potm',
    'potx',
    'pps',
    'ppsm',
    'ppsx',
    'ppt',
    'pptm',
    'pptx',
    'doc',
    'docm',
    'docx',
    'dot',
    'dotm',
    'dotx',
    'odt',
    'pdf',
    'xml',
  ],
};
